export default __webpack_public_path__ + "locales/zh-CN/Files.json?hash=3f373c37d1611332c0508d10179d7ffc";